<template>
  <modal-brandme :key="change_modal" :show_modal="modal_list" closeIcon="close-white-card-section" :size="'lg'" @hidden="closeModal" :bg_title="'bg-modal-chat-section'" :bg_body="'bg-modal-body-chat-section'" :class_footer="'footer-modal-chat-section'">
    <template #title="">
        <span class="text-white">
          Compra "{{ list.title }}"
        </span>
    </template>
    <template #body="">
      <b-row>
        <b-col>
          <b-img class="img-modal" :src="list.cover"></b-img>
        </b-col>
        <b-col>
          <b-col class="mt-2">
            <span clasS="avenir-medium">{{ list.description }}</span>
          </b-col>
        </b-col>
      </b-row>
    </template>

    <template #footer="">
      <b-button pill variant="primary" @click="paidList" :disabled="loading">${{list.price}} USD</b-button>
    </template>


  </modal-brandme>
</template>
  
<script>
import { BRow, BCol, BImg, BButton } from "bootstrap-vue";
import { paidList } from '@/services/lists';

export default {
  name: "modalPaidList",
  components: {
    BRow,
    BCol,
    BImg,
    BButton,
    modalBrandme: () => import('@/views/components/modal/ModalBrandme.vue')
  },
  props: {
    list: {
      type: Object
    },
    open_modal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      change_modal: false,
      modal_list: this.open_modal,
      loading: false
    };
  },
  methods: {
    closeModal() {
      this.change_modal = !this.change_modal
      this.modal_list = false
      this.$emit('close_modal')
    },
    paidList () {
      this.loading = true;
      paidList(this.list.uuid).then((response) => {
        window.location.href = response.checkout_url;
        this.loading = false;
      });
    }
  },
};
</script>
<style scopped>
.img-modal {
  max-width: 50%;
  border-radius: 5%;
}
</style>